import { Button, colors, Loading } from '@leapeasy/ui-kit';
import React from 'react';
import styled from 'styled-components';

export const CancelDialog = ({
  img,
  title,
  detail,
  noFunc,
  yesFunc,
  isSubmitting = false,
  yesLabel = 'Yes, Delete',
  noLabel = 'Discard',
  confirmVariant = 'primary',
}) => (
  <CancelContainer col1={colors.purple[900]} col2={colors.neutral[900]}>
    <img src={img} alt="" />
    <p>{title}</p>
    <p>{detail}</p>
    <div>
      <Button
        size="medium"
        variant="tertiary"
        style={{ flexShrink: 2 }}
        onClick={noFunc}
        disabled={isSubmitting}
      >
        {noLabel}
      </Button>

      <Button
        size="medium"
        variant="primary"
        style={{
          flexShrink: 2,
          ...(confirmVariant === 'destructive'
            ? { backgroundColor: '#702572', border: 'none' }
            : {}),
        }}
        onClick={yesFunc}
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <SubmittingLabel>
            <Loading size="small" />
            Cancelling…
          </SubmittingLabel>
        ) : (
          yesLabel
        )}
      </Button>
    </div>
  </CancelContainer>
);

const SubmittingLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const CancelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  width: 350px;
  text-align: center;
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  & > p:nth-of-type(1) {
    color: ${(props) => props.col1};
    font-size: 14px;
    font-weight: 600;
  }

  & > p:nth-of-type(2) {
    color: ${(props) => props.col2};
    font-size: 12px;
    font-weight: 400;
  }

  & > div {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    width: 100%;

    button {
      flex: 1;
    }
  }
`;
